import { useAccount } from '@/hooks/useAccount';

import { getBodyShapeIdByTitle } from '../options/BodyShape/utils/getBodyShapeIdByTitle';
import { getHairColorIdByTitle } from '../options/HairColor/utils/getHairColorIdByTitle';
import { getAiAgeGeneration } from '../utils/getAiAgeGeneration';

export const useLayoutSelections = () => {
  const { user } = useAccount();

  const ageGeneration = getAiAgeGeneration(user?.onboarding_data?.age);
  const bodyShape = getBodyShapeIdByTitle(
    user?.onboarding_data?.body_shape,
    true,
  );
  const hairColor = getHairColorIdByTitle(
    user?.onboarding_data?.hair_color,
    true,
  );

  return {
    ageGeneration,
    bodyShape,
    hairColor,
  };
};
